import { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AppProvider } from './stores/store'
import { useChangeLocalhostUrl } from './shared'
import { AppTypeProvider, useAppType } from './contexts/AppTypeContext'
import { isMediLabApp, isMelphinApp, isAnnotatorUser } from './types/appType'
import MediLabApp from './apps/medilab/App'
import TMNApp from './apps/tmn/App'
import AnnotatorApp from './apps/annotator/App'
import MelphinApp from './apps/melphin/App'
import { queryClient } from './shared'

const Pages = () => {
  const { appType } = useAppType()

  // annotatorユーザーは専用アプリに分岐（最優先）
  if (isAnnotatorUser()) {
    return <AnnotatorApp />
  }

  // アプリタイプに基づいて完全に分離されたアプリを表示
  if (isMediLabApp(appType)) {
    return <MediLabApp />
  } else if (isMelphinApp(appType)) {
    return <MelphinApp />
  } else {
    return <TMNApp />
  }
}

const App: FC = () => {
  useChangeLocalhostUrl()
  return (
    <AppProvider>
      <QueryClientProvider client={queryClient}>
        <AppTypeProvider>
          <BrowserRouter>
            <Pages />
          </BrowserRouter>
        </AppTypeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AppProvider>
  )
}

export default App
